import React, {useState, useEffect} from 'react'
import {Button, Input, message, Modal, Popconfirm, Select} from "antd";
import {editTenantFee} from "../../../../../../services/api/apiCustomerHub";
import {Option} from "antd/es/mentions";
import parseToken from "../../../../../../helpers/parseToken";
import {formatCurrency} from "../../../../../../helpers/convertArrayToObject";

function TenantFeeEditModal(props) {
    const {custId, listTelco, isOpen, toggleModal, fetchTenantFee, feeItem} = props
    const [validate, setValidate] = useState({})
    const [loading, setLoading] = useState(false)
    const [itemEdit, setItemEdit] = useState({})
    const decodeToken = parseToken()

    useEffect(() => {
        if (feeItem) {
            const telcoParts = feeItem.telco ? feeItem.telco.split('_') : []
            setItemEdit({
                tenantFeeId: feeItem.tenantFeeId,
                description: feeItem.description || '',
                callerPrefix: telcoParts[0] || '',
                calledPrefix: telcoParts[1] || '',
                fee: feeItem.fee || '',
            })
        }
    }, [feeItem])

    const handleCancel = () => {
        toggleModal()
    }

    const handleChangeItemEdit = (name, value) => {
        if (name === 'fee') {
            const rawValue = value.replace(/[^0-9]/g, '')
            setItemEdit({
                ...itemEdit,
                [name]: rawValue
            })
        } else {
            setItemEdit({
                ...itemEdit,
                [name]: value
            })
        }
    }

    const _validateData = () => {
        let validateForm = {}
        if (!itemEdit?.description) {
            Object.assign(validateForm, {description: 'Gói cước là bắt buộc'})
        }
        if (!itemEdit?.callerPrefix) {
            Object.assign(validateForm, {callerPrefix: 'Hướng là bắt buộc'})
        }
        if (!itemEdit?.calledPrefix) {
            Object.assign(validateForm, {calledPrefix: 'Hướng là bắt buộc'})
        }
        if (itemEdit?.fee === undefined || itemEdit?.fee === '') {
            Object.assign(validateForm, {fee: 'Giá là bắt buộc'})
        }

        setValidate(validateForm)
        return validateForm
    }

    const _updateTenantFee = async () => {
        try {
            setLoading(true)
            const validateCheck = _validateData()
            if (Object.keys(validateCheck).length > 0) {
                setLoading(false)
                message.error("Dữ liệu không hợp lệ")
                return false
            }
            const feeValue = typeof itemEdit.fee === 'string' ? itemEdit.fee.replace(/[^0-9]/g, '') : itemEdit.fee
            const payload = {
                tenantFeeId: itemEdit.tenantFeeId,
                description: itemEdit.description,
                telco: `${itemEdit?.callerPrefix}_${itemEdit?.calledPrefix}`,
                fee: Number(feeValue),
                tenantId: custId,
            }
            const response = await editTenantFee(decodeToken.sub, payload)
            setLoading(false)
            const {success, error_message} = response
            if (parseInt(success) !== 1) {
                return message.error(error_message)
            }
            message.success('Cập nhật thành công!')
            toggleModal()
            fetchTenantFee()
        } catch (e) {
            setLoading(false)
            message.error(e.message)
        }
    }

    return (
        <Modal
            title="Sửa Giá cước"
            className={`ModalCustom2`}
            style={{top: 20}}
            maskClosable={false}
            open={isOpen}
            onCancel={handleCancel}
            footer={[
                <div className="Actions d-flex justify-content-end align-items-center">
                    <Popconfirm placement="top" title="Bạn chắc chắn muốn thoát?" onConfirm={handleCancel} okText="Yes"
                                cancelText="No">
                        <Button key="back" type="link" disable={loading}>
                            Cancel
                        </Button>
                    </Popconfirm>
                    <Button key="submit" type="primary" onClick={_updateTenantFee} loading={loading}>
                        Save
                    </Button>
                </div>
            ]}
        >
            <div className="FormEdit">
                <div className="row">
                    <div className="FormField col-md-12">
                        <label className="Label">
                            Gói cước
                            <span className="Required">*</span>
                        </label>
                        <Input value={itemEdit?.description}
                               onChange={(e) => handleChangeItemEdit('description', e.target.value)} type="text"/>
                        {
                            validate?.description &&
                            <span className="Error text-danger mt-1">{validate?.description}</span>
                        }
                    </div>
                    <div className="FormField col-md-12">
                        <label className="Label">
                            Hướng
                            <span className="Required">*</span>
                        </label>
                        <div className="row">
                            <div className="col-md-6">
                                <Select className="mr-3"
                                        value={itemEdit?.callerPrefix || undefined}
                                        onChange={(value) => handleChangeItemEdit('callerPrefix', value)}
                                        placeholder="Chọn" style={{width: '100%', minWidth: '150px'}}>
                                    {
                                        listTelco.map(item => {
                                            return <Option value={item.code} key={item.code}>{item.name}</Option>
                                        })
                                    }
                                </Select>
                                {
                                    validate?.callerPrefix &&
                                    <span className="Error text-danger mt-1">{validate?.callerPrefix}</span>
                                }
                            </div>
                            <div className="col-md-6">
                                <Select value={itemEdit?.calledPrefix || undefined}
                                        onChange={(value) => handleChangeItemEdit('calledPrefix', value)}
                                        placeholder="Chọn" style={{width: '100%', minWidth: '150px'}}>
                                    {
                                        listTelco.map(item => {
                                            return <Option value={item.code} key={item.code}>{item.name}</Option>
                                        })
                                    }
                                </Select>
                                {
                                    validate?.calledPrefix &&
                                    <span className="Error text-danger mt-1">{validate?.calledPrefix}</span>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="FormField col-md-12">
                        <label className="Label">
                            Giá
                            <span className="Required">*</span>
                        </label>
                        <Input value={itemEdit?.fee ? formatCurrency(Number(itemEdit.fee), 'en') : ''}
                               onChange={(e) => handleChangeItemEdit('fee', e.target.value)} type="text"/>
                        {
                            validate?.fee && <span className="Error text-danger mt-1">{validate?.fee}</span>
                        }
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default TenantFeeEditModal
